import { BreakMaterial, BreakProfile } from './breakTypes';

export const BREAK_PROFILES: Record<string, BreakProfile> = {
  foldingTable: {
    id: 'foldingTable',
    material: 'wood',
    patterns: ['horizontal-split', 'corner-impact'],
    pieceCount: [7, 12],
    fragmentShapes: ['panel', 'sliver', 'chunk'],
    velocityMultiplier: 1.05,
    angularVelocityRange: [0.035, 0.12],
    lifespanMs: [2600, 4200],
    fadeDelayMs: [1100, 2200],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.wood.table'
  },
  oldTv: {
    id: 'oldTv',
    material: 'electronics',
    patterns: ['radial', 'crush'],
    pieceCount: [10, 17],
    fragmentShapes: ['chunk', 'panel', 'shard'],
    velocityMultiplier: 0.95,
    angularVelocityRange: [0.025, 0.1],
    lifespanMs: [2800, 4800],
    fadeDelayMs: [1400, 2600],
    dust: true,
    sparks: true,
    smoke: true,
    soundProfile: 'break.electronics.tv'
  },
  neonSign: {
    id: 'neonSign',
    material: 'glass',
    patterns: ['radial', 'horizontal-split'],
    pieceCount: [14, 24],
    fragmentShapes: ['shard', 'sliver'],
    velocityMultiplier: 1.35,
    angularVelocityRange: [0.08, 0.22],
    lifespanMs: [1800, 3600],
    fadeDelayMs: [800, 1700],
    dust: false,
    sparks: true,
    smoke: false,
    soundProfile: 'break.glass.neon'
  },
  garageWindow: {
    id: 'garageWindow',
    material: 'glass',
    patterns: ['radial', 'vertical-split'],
    pieceCount: [16, 28],
    fragmentShapes: ['shard', 'sliver'],
    velocityMultiplier: 1.45,
    angularVelocityRange: [0.08, 0.24],
    lifespanMs: [1800, 3300],
    fadeDelayMs: [700, 1600],
    dust: false,
    sparks: false,
    smoke: false,
    soundProfile: 'break.glass.window'
  },
  speakerStack: {
    id: 'speakerStack',
    material: 'electronics',
    patterns: ['vertical-split', 'crush'],
    pieceCount: [9, 16],
    fragmentShapes: ['panel', 'chunk', 'sliver'],
    velocityMultiplier: 0.9,
    angularVelocityRange: [0.025, 0.09],
    lifespanMs: [3000, 5200],
    fadeDelayMs: [1500, 2800],
    dust: true,
    sparks: true,
    smoke: false,
    soundProfile: 'break.electronics.speaker'
  },
  paintCan: {
    id: 'paintCan',
    material: 'metal',
    patterns: ['radial', 'corner-impact'],
    pieceCount: [6, 11],
    fragmentShapes: ['chunk', 'sliver', 'splatter'],
    velocityMultiplier: 1.25,
    angularVelocityRange: [0.05, 0.18],
    lifespanMs: [2400, 4200],
    fadeDelayMs: [1000, 2200],
    dust: false,
    sparks: false,
    smoke: false,
    soundProfile: 'break.metal.can'
  },
  questionableCake: {
    id: 'questionableCake',
    material: 'cake',
    patterns: ['soft-burst', 'crush'],
    pieceCount: [8, 15],
    fragmentShapes: ['chunk', 'splatter'],
    velocityMultiplier: 0.72,
    angularVelocityRange: [0.015, 0.055],
    gravityScale: 1.15,
    lifespanMs: [2200, 3800],
    fadeDelayMs: [800, 1600],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.soft.cake'
  },
  cooler: {
    id: 'cooler',
    material: 'metal',
    patterns: ['horizontal-split', 'crush'],
    pieceCount: [7, 12],
    fragmentShapes: ['panel', 'chunk', 'sliver'],
    velocityMultiplier: 0.9,
    angularVelocityRange: [0.025, 0.095],
    lifespanMs: [2800, 4600],
    fadeDelayMs: [1300, 2400],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.metal.cooler'
  },
  garageShelf: {
    id: 'garageShelf',
    material: 'wood',
    patterns: ['horizontal-split', 'vertical-split'],
    pieceCount: [9, 15],
    fragmentShapes: ['panel', 'sliver', 'chunk'],
    velocityMultiplier: 0.88,
    angularVelocityRange: [0.025, 0.105],
    lifespanMs: [3000, 5000],
    fadeDelayMs: [1500, 2800],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.wood.shelf'
  },
  cableBin: {
    id: 'cableBin',
    material: 'soft',
    patterns: ['soft-burst', 'corner-impact'],
    pieceCount: [7, 13],
    fragmentShapes: ['sliver', 'chunk'],
    velocityMultiplier: 0.78,
    angularVelocityRange: [0.02, 0.075],
    lifespanMs: [2600, 4300],
    fadeDelayMs: [1100, 2200],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.soft.cable'
  },
  mysteryBox: {
    id: 'mysteryBox',
    material: 'wood',
    patterns: ['radial', 'corner-impact'],
    pieceCount: [7, 12],
    fragmentShapes: ['panel', 'chunk', 'sliver'],
    velocityMultiplier: 1.1,
    angularVelocityRange: [0.04, 0.14],
    lifespanMs: [2600, 4300],
    fadeDelayMs: [1100, 2300],
    dust: true,
    sparks: false,
    smoke: false,
    soundProfile: 'break.wood.box'
  },
  tinyDrumKit: {
    id: 'tinyDrumKit',
    material: 'metal',
    patterns: ['radial', 'crush'],
    pieceCount: [10, 18],
    fragmentShapes: ['chunk', 'sliver', 'panel'],
    velocityMultiplier: 1.08,
    angularVelocityRange: [0.04, 0.16],
    lifespanMs: [2600, 4500],
    fadeDelayMs: [1000, 2300],
    dust: false,
    sparks: true,
    smoke: false,
    soundProfile: 'break.metal.drums'
  }
};

export const FALLBACK_PROFILE_BY_MATERIAL: Record<BreakMaterial, string> = {
  glass: 'garageWindow',
  wood: 'foldingTable',
  metal: 'paintCan',
  soft: 'cableBin',
  electronics: 'oldTv',
  cake: 'questionableCake'
};

export function getBreakProfile(profileId: string | undefined, material: BreakMaterial) {
  return BREAK_PROFILES[profileId ?? ''] ?? BREAK_PROFILES[FALLBACK_PROFILE_BY_MATERIAL[material]];
}
